import hapanaPattern from '@hapana/shared/web/styles/assets/images/hapana-pattern.png'

/** @type {Styles} */

export const styles = {
  form: {
    width: '100%',
    height: '100vh',
    backgroundColor: { xs: 'white', sm: 'info.lightest' },
    overflow: 'auto',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: { xs: 'flex-start', sm: 'center' },
    alignItems: 'center',
    position: 'relative',
    gap: { xs: 2, sm: 5 },
    paddingX: { xs: 0, sm: '2.5' },
    paddingY: 5,
    minHeight: '100vh',
    overflow: 'auto',
  },
  flexCenter: { display: 'flex', justifyContent: 'center' },
  logo: { width: { xs: 160, sm: 216 } },
  credentialsContainer: {
    borderRadius: { xs: 'unset', sm: 4 },
    borderStyle: { xs: 'unset', sm: 'solid' },
    borderWidth: 1,
    padding: { xs: 3, sm: 5 },
    borderColor: 'info.light',
    backgroundColor: { xs: 'white', sm: 'custom.user.background' },
    gap: 3,
  },
  title: { color: 'primary.dark' },
  button: { width: '100%' },
  forgotPasswordContainer: {
    width: 'fit-content',
  },
  forgotPasswordLabel: { color: 'gray.64' },
  getHelpSigningLabel: { color: 'primary.main', cursor: 'pointer' },
  subtitle: { marginTop: 1, color: 'gray.64' },
  formRoot: {
    width: { xs: '100%', sm: 438 },
    backgroundColor: 'white',
    zIndex: 1,
    borderRadius: { xs: 'unset', sm: 4 },
  },
  inactivityAlert: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1300,
    borderRadius: 0,
  },
  subtitleGray: { color: 'gray.64' },
  errorBox: {
    backgroundColor: '#FEE',
    border: '1px solid #FCC',
    borderRadius: 1,
    padding: 1.5,
    color: '#D8000C',
  },
  linkText: { color: 'primary.main', cursor: 'pointer', fontWeight: 500 },
  textCenter: { textAlign: 'center' },
  captionResend: { fontSize: '0.85rem' },
  backgroundPatternImage: {
    backgroundImage: `url(${hapanaPattern})`,
    backgroundSize: 'cover',
    backgroundPosition: 'bottom',
    position: 'absolute',
    height: 248,
    width: '100%',
    bottom: 0,
    left: 0,
    right: 0,
    display: { xs: 'none', sm: 'block' },
  },
}
